import { ValidMember } from "Components/Members/MembersHelper";
import { create } from "zustand";

interface State {
	validMembers: ValidMember[];
	setValidMembers: (validMembers: ValidMember[]) => void;
}

export const useComputedCompany = create<State>((set) => ({
	validMembers: [],
	setValidMembers: (validMembers) => set({ validMembers }),
}));
